import React, { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Template } from './types';

interface DocumentManagementContextType {
  activeView: string;
  isAdminLogin: boolean;
  setActiveView: (view: string) => void;
  openCreatePage: (
    documentId?: string,
    documentName?: string,
    selectedCategory?: string,
    template?: Template | Template[]
  ) => void;
  handleAssign: (templateId: string, employeeIds: string[]) => void;
}

const DocumentManagementContext = createContext<DocumentManagementContextType | undefined>(
  undefined
);

export const DocumentManagementProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const navigate = useNavigate();
  const [activeView, setActiveView] = useState('assigned');

    const loginInfo = localStorage.getItem('user-details');
    const userDetails = loginInfo ? JSON.parse(loginInfo) : null;

    const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}') as {
      projectId?: string;
      projectName?: string;
      isAdmin?: boolean;
    };
    const isAdminLogin =
      selectedProject?.isAdmin === true &&
      userDetails?.role?.some((r: any) => r.label.toLowerCase() === 'admin');


  const openCreatePage = (documentId?: string, documentName?: string, selectedCategory?: string) => {
    setActiveView('create');
    navigate('/payroll/documents/create', { state: { documentId, documentName, selectedCategory } });
  };

  const handleAssign = (templateId: string, employeeIds: string[]) => {
    console.log(`Assigned template ${templateId} to employees: ${employeeIds.join(', ')}`);
    setActiveView('templates');
    navigate('/payroll/documents/templates');
  };

  return (
    <DocumentManagementContext.Provider
      value={{ activeView, setActiveView, openCreatePage, handleAssign, isAdminLogin }}
    >
      {children}
    </DocumentManagementContext.Provider>
  );
};

export const useDocumentManagement = () => {
  const context = useContext(DocumentManagementContext);
  if (!context) {
    throw new Error('useDocumentManagement must be used within a DocumentManagementProvider');
  }
  return context;
};
